// FETCH ALL PROPERTIES FROM GARMENTS_DC DETAILS
export const FETCH_GARMENTS_PO_DETAILS_REQUEST = 'FETCH_GARMENTS_PO_DETAILS_REQUEST';
export const FETCH_GARMENTS_PO_DETAILS_SUCCESS = 'FETCH_GARMENTS_PO_DETAILS_SUCCESS';
export const FETCH_GARMENTS_PO_DETAILS_FAILURE = 'FETCH_GARMENTS_PO_DETAILS_FAILURE';

export const FETCH_GARMENTS_PO_DETAILS_SIZE_GRID_REQUEST = 'FETCH_GARMENTS_PO_DETAILS_SIZE_GRID_REQUEST';
export const FETCH_GARMENTS_PO_DETAILS_SIZE_GRID_SUCCESS = 'FETCH_GARMENTS_PO_DETAILS_SIZE_GRID_SUCCESS';
export const FETCH_GARMENTS_PO_DETAILS_SIZE_GRID_FAILURE = 'FETCH_GARMENTS_PO_DETAILS_SIZE_GRID_FAILURE';

export const FETCH_GARMENTS_PO_DETAILS_FORM_REQUEST = 'FETCH_GARMENTS_PO_DETAILS_FORM_REQUEST';
export const FETCH_GARMENTS_PO_DETAILS_FORM_SUCCESS = 'FETCH_GARMENTS_PO_DETAILS_FORM_SUCCESS';
export const FETCH_GARMENTS_PO_DETAILS_FORM_FAILURE = 'FETCH_GARMENTS_PO_DETAILS_FORM_FAILURE';

// FETCH ALL PROPERTIES FROM GARMENTS_PO DETAILS
export const FETCH_GENERATE_SKU_STYLE_GARMENTS_PO_DETAILS_REQUEST = 'FETCH_GENERATE_SKU_STYLE_GARMENTS_PO_DETAILS_REQUEST';
export const FETCH_GENERATE_SKU_STYLE_GARMENTS_PO_DETAILS_SUCCESS = 'FETCH_GENERATE_SKU_STYLE_GARMENTS_PO_DETAILS_SUCCESS';
export const FETCH_GENERATE_SKU_STYLE_GARMENTS_PO_DETAILS_FAILURE = 'FETCH_GENERATE_SKU_STYLE_GARMENTS_PO_DETAILS_FAILURE';

// FETCH ALL PROPERTIES FROM GARMENTS_PO DETAILS
export const FETCH_GARMENTS_PO_PROGRAM_REQUEST = 'FETCH_GARMENTS_PO_PROGRAM_REQUEST';
export const FETCH_GARMENTS_PO_PROGRAM_SUCCESS = 'FETCH_GARMENTS_PO_PROGRAM_SUCCESS';
export const FETCH_GARMENTS_PO_PROGRAM_FAILURE = 'FETCH_GARMENTS_PO_PROGRAM_FAILURE';

// FETCH ALL PROPERTIES FROM GARMENTS_PO DETAILS
export const FETCH_GARMENTS_PO_DETAIL_STYLE_REQUEST = 'FETCH_GARMENTS_PO_DETAIL_STYLE_REQUEST';
export const FETCH_GARMENTS_PO_DETAIL_STYLE_SUCCESS = 'FETCH_GARMENTS_PO_DETAIL_STYLE_SUCCESS';
export const FETCH_GARMENTS_PO_DETAIL_STYLE_FAILURE = 'FETCH_GARMENTS_PO_DETAIL_STYLE_FAILURE';

export const FETCH_GRN_NO_BY_GARMENTS_PO_NO_REQUEST = 'FETCH_GRN_NO_BY_GARMENTS_PO_NO_REQUEST';
export const FETCH_GRN_NO_BY_GARMENTS_PO_NO_SUCCESS = 'FETCH_GRN_NO_BY_GARMENTS_PO_NO_SUCCESS';
export const FETCH_GRN_NO_BY_GARMENTS_PO_NO_FAILURE = 'FETCH_GRN_NO_BY_GARMENTS_PO_NO_FAILURE';

// FETCH ALL PROPERTIES FROM GARMENTS_PO DETAILS
export const FETCH_GARMENTS_PO_DETAILS_DC_NO_REQUEST = 'FETCH_GARMENTS_PO_DETAILS_DC_NO_REQUEST';
export const FETCH_GARMENTS_PO_DETAILS_DC_NO_SUCCESS = 'FETCH_GARMENTS_PO_DETAILS_DC_NO_SUCCESS';
export const FETCH_GARMENTS_PO_DETAILS_DC_NO_FAILURE = 'FETCH_GARMENTS_PO_DETAILS_DC_NO_FAILURE';

// FETCH ALL PROPERTIES FROM GARMENTS_PO DETAILS BY ID
export const FETCH_GARMENTS_PO_DETAILS_BY_ID_REQUEST = 'FETCH_GARMENTS_PO_DETAILS_BY_ID_REQUEST';
export const FETCH_GARMENTS_PO_DETAILS_BY_ID_SUCCESS = 'FETCH_GARMENTS_PO_DETAILS_BY_ID_SUCCESS';
export const FETCH_GARMENTS_PO_DETAILS_BY_ID_FAILURE = 'FETCH_GARMENTS_PO_DETAILS_BY_ID_FAILURE';

// CREATE PROPERTIES FOR GARMENTS_PO DETAILS
export const CREATE_GARMENTS_PO_DETAILS_REQUEST = 'CREATE_GARMENTS_PO_DETAILS_REQUEST';
export const CREATE_GARMENTS_PO_DETAILS_SUCCESS = 'CREATE_GARMENTS_PO_DETAILS_SUCCESS';
export const CREATE_GARMENTS_PO_DETAILS_FAILURE = 'CREATE_GARMENTS_PO_DETAILS_FAILURE';

// CREATE PROPERTIES FOR GARMENTS_PO DETAILS
export const CREATE_GARMENTS_PO_DETAILS_GRID_REQUEST = 'CREATE_GARMENTS_PO_DETAILS_GRID_REQUEST';
export const CREATE_GARMENTS_PO_DETAILS_GRID_SUCCESS = 'CREATE_GARMENTS_PO_DETAILS_GRID_SUCCESS';
export const CREATE_GARMENTS_PO_DETAILS_GRID_FAILURE = 'CREATE_GARMENTS_PO_DETAILS_GRID_FAILURE';

// CREATE PROPERTIES FOR GARMENTS_PO DETAILS
export const CREATE_GARMENTS_PO_DETAILS_SKU_STYLE_REQUEST = 'CREATE_GARMENTS_PO_DETAILS_SKU_STYLE_REQUEST';
export const CREATE_GARMENTS_PO_DETAILS_SKU_STYLE_SUCCESS = 'CREATE_GARMENTS_PO_DETAILS_SKU_STYLE_SUCCESS';
export const CREATE_GARMENTS_PO_DETAILS_SKU_STYLE_FAILURE = 'CREATE_GARMENTS_PO_DETAILS_SKU_STYLE_FAILURE';

//CREATE USER FORM
export const CREATE_USER_FORM_GARMENTS_PO_DETAILS = 'CREATE_USER_FORM_GARMENTS_PO_DETAILS';
export const RESET_GARMENTS_PO_DETAIL_GENERATE_SKU = 'RESET_GARMENTS_PO_DETAIL_GENERATE_SKU';

// UPDATE PROPERTIES FOR GARMENTS_PO DETAILS
export const UPDATE_GARMENTS_PO_DETAILS_REQUEST = 'UPDATE_GARMENTS_PO_DETAILS_REQUEST';
export const UPDATE_GARMENTS_PO_DETAILS_SUCCESS = 'UPDATE_GARMENTS_PO_DETAILS_SUCCESS';
export const UPDATE_GARMENTS_PO_DETAILS_FAILURE = 'UPDATE_GARMENTS_PO_DETAILS_FAILURE';

// FETCH SINGLE GARMENTS_PO_DETAILS
export const FETCH_SINGLE_GARMENTS_PO_DETAILS_REQUEST = 'FETCH_SINGLE_GARMENTS_PO_DETAILS_REQUEST';
export const FETCH_SINGLE_GARMENTS_PO_DETAILS_SUCCESS = 'FETCH_SINGLE_GARMENTS_PO_DETAILS_SUCCESS';
export const FETCH_SINGLE_GARMENTS_PO_DETAILS_FAILURE = 'FETCH_SINGLE_GARMENTS_PO_DETAILS_FAILURE';

// DELETE PROPERTIES FOR GARMENTS_PO DETAILS
export const DELETE_GARMENTS_PO_DETAILS_REQUEST = 'DELETE_GARMENTS_PO_DETAILS_REQUEST';
export const DELETE_GARMENTS_PO_DETAILS_SUCCESS = 'DELETE_GARMENTS_PO_DETAILS_SUCCESS';
export const DELETE_GARMENTS_PO_DETAILS_FAILURE = 'DELETE_GARMENTS_PO_DETAILS_FAILURE';

export const FETCH_GARMENTS_PO_PREVIOUS_LIST_REQUEST = 'FETCH_GARMENTS_PO_PREVIOUS_LIST_REQUEST';
export const FETCH_GARMENTS_PO_PREVIOUS_LIST_SUCCESS = 'FETCH_GARMENTS_PO_PREVIOUS_LIST_SUCCESS';
export const FETCH_GARMENTS_PO_PREVIOUS_LIST_FAILURE = 'FETCH_GARMENTS_PO_PREVIOUS_LIST_FAILURE';

// USERFORM RESET

export const GARMENTS_PO_DETAILS_USERFORM_RESET = 'GARMENTS_PO_DETAILS_USERFORM_RESET';

export const GARMENTS_PO_DETAILS_GENERATE_GRID_OUTPUT_DATA_SET = 'GARMENTS_PO_DETAILS_GENERATE_GRID_OUTPUT_DATA_SET';

export const GARMENTS_PO_DETAILS_GENERATE_GRID_FINAL_DATA_SET = 'GARMENTS_PO_DETAILS_GENERATE_GRID_FINAL_DATA_SET';
export const CREATE_USER_FORM_GARMENTS_PO_EDIT_QTY = 'CREATE_USER_FORM_GARMENTS_PO_EDIT_QTY';

export const GARMENTS_EDITABLE_QUANTITY_VALUE_REQUEST = 'GARMENTS_EDITABLE_QUANTITY_VALUE_REQUEST'
export const GARMENTS_EDITABLE_QUANTITY_VALUE_SUCCESS = 'GARMENTS_EDITABLE_QUANTITY_VALUE_SUCCESS'
export const GARMENTS_EDITABLE_QUANTITY_VALUE_FALIURE = 'GARMENTS_EDITABLE_QUANTITY_VALUE_FALIURE'

export const INITAIL_LOADED_GRID_DATA_SIZE = 'INITAIL_LOADED_GRID_DATA_SIZE'

export const GARMENTS_EDITABLE_INNER_QUANTITY_VALUE_REQUEST = 'GARMENTS_EDITABLE_INNER_QUANTITY_VALUE_REQUEST'
export const GARMENTS_EDITABLE_INNER_QUANTITY_VALUE_SUCCESS = 'GARMENTS_EDITABLE_INNER_QUANTITY_VALUE_SUCCESS'
export const GARMENTS_EDITABLE_INNER_QUANTITY_VALUE_FALIURE = 'GARMENTS_EDITABLE_INNER_QUANTITY_VALUE_FALIURE'


export const FETCH_GARMENTS_PO_DETAILS_BY_INNER_GRID_REQUEST = 'FETCH_GARMENTS_PO_DETAILS_BY_INNER_GRID_REQUEST';
export const FETCH_GARMENTS_PO_DETAILS_BY_INNER_GRID_SUCCESS = 'FETCH_GARMENTS_PO_DETAILS_BY_INNER_GRID_SUCCESS';
export const FETCH_GARMENTS_PO_DETAILS_BY_INNER_GRID_FAILURE = 'FETCH_GARMENTS_PO_DETAILS_BY_INNER_GRID_FAILURE';


export const GARMENTS_PO_PROGRAM_ID_REQUEST = 'GARMENTS_PO_PROGRAM_ID_REQUEST';
export const GARMENTS_PO_PROGRAM_ID_SUCCESS = 'GARMENTS_PO_PROGRAM_ID_SUCCESS';
export const GARMENTS_PO_PROGRAM_ID_FALIURE = 'GARMENTS_PO_PROGRAM_ID_FALIURE';


export const GARMENTS_PO_DETAILS_DELETE_FABRIC_REQUEST = 'GARMENTS_PO_DETAILS_DELETE_FABRIC_REQUEST';
export const GARMENTS_PO_DETAILS_DELETE_FABRIC_SUCCESS = 'GARMENTS_PO_DETAILS_DELETE_FABRIC_SUCCESS';
export const GARMENTS_PO_DETAILS_DELETE_FABRIC_FAILURE = 'GARMENTS_PO_DETAILS_DELETE_FABRIC_FAILURE';


export const GARMENTS_PO_DETAILS_DELETE_REQUEST = 'GARMENTS_PO_DETAILS_DELETE_REQUEST';
export const GARMENTS_PO_DETAILS_DELETE_SUCCESS = 'GARMENTS_PO_DETAILS_DELETE_SUCCESS';
export const GARMENTS_PO_DETAILS_DELETE_FAILURE = 'GARMENTS_PO_DETAILS_DELETE_FAILURE';



export const CHECK_ALL_UPDATE_REQUEST = 'CHECK_ALL_UPDATE_REQUEST';
export const CHECK_ALL_UPDATE_SUCCESS = 'CHECK_ALL_UPDATE_SUCCESS';
export const CHECK_ALL_UPDATE_FAILURE = 'CHECK_ALL_UPDATE_FAILURE';


export const RESET_USER_FORM_TO_DEFAULT = 'RESET_USER_FORM_TO_DEFAULT'

export const FETCH_GARMENTS_PO_DETAILS_BY_ID_RESET = 'FETCH_GARMENTS_PO_DETAILS_BY_ID_RESET';



export const GET_GARMENTPO_WITH_ACC_REQUEST = 'GET_GARMENTPO_WITH_ACC_REQUEST';
export const GET_GARMENTPO_WITH_ACC_SUCCESS = 'GET_GARMENTPO_WITH_ACC_SUCCESS';
export const GET_GARMENTPO_WITH_ACC_FAILURE = 'GET_GARMENTPO_WITH_ACC_FAILURE';


export const CREATE_GARMENTPO_WITH_ACC_REQUEST = 'CREATE_GARMENTPO_WITH_ACC_REQUEST';
export const CREATE_GARMENTPO_WITH_ACC_SUCCESS = 'CREATE_GARMENTPO_WITH_ACC_SUCCESS';
export const CREATE_GARMENTPO_WITH_ACC_FAILURE = 'CREATE_GARMENTPO_WITH_ACC_FAILURE';



export const CREATE_USER_FORM_GARMENTPO_WITH_ACC_GENERATE_QTY = 'CREATE_USER_FORM_GARMENTPO_WITH_ACC_GENERATE_QTY';

export const GARMENTPO_WITH_ACC_REQUEST = 'GARMENTPO_WITH_ACC_REQUEST';
export const GARMENTPO_WITH_ACC_SUCCESS = 'GARMENTPO_WITH_ACC_SUCCESS';
export const GARMENTPO_WITH_ACC_FAILURE = 'GARMENTPO_WITH_ACC_FAILURE';

export const RESET_TO_GARMENTPO_ACC_PERVIOUS_LIST = 'RESET_TO_GARMENTPO_ACC_PERVIOUS_LIST';

export const DELETE_GARMENTS_PO_ACC_REQUEST = 'DELETE_GARMENTS_PO_ACC_REQUEST';
export const DELETE_GARMENTS_PO_ACC_SUCCESS = 'DELETE_GARMENTS_PO_ACC_SUCCESS';
export const DELETE_GARMENTS_PO_ACC_FAILURE = 'DELETE_GARMENTS_PO_ACC_FAILURE';           
